import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import DatatableExpand from "../../Constants/DatatableExpand";
import { Row, Col, Label, Container } from "reactstrap";
import { PENCIL, LOGOUT_ICON } from "../../Constants/SrcImages";
import {validateTokenStorage} from './../../Constants/Util';
import { COLUMNS_GRADES, EXPAND_ROW_GRADE_HOUR } from "../../Constants/DatatableColumns";
import { getGrades, getAllsignature, getHourByGrade, postHour, putHour, deleteHour } from "../../Constants/Services";
import { IGrades, IGradeSelected, IHour, IAsignature, IDiasByAsignatures } from "../../Constants/Interfaces";
import { HorarioModal } from "./../../Constants/Modal";
import moment from "moment";

interface IHourState {
  formDias: IDiasByAsignatures;
  dataAsignature: IAsignature[];
  dataHour: IHour[];
  dataGrades: IGrades[];
  dataGradeSelected: IGradeSelected;
  isOpenModalAddHour: boolean;
  isOpenModalEditHour: boolean;
  loading: boolean;
  msg_error:string;
}

class Hour extends Component<RouteComponentProps<{}>, IHourState> {
  constructor(props: any) {
    super(props);
    this.state = {
      dataHour: [],
      dataAsignature: [],
      formDias: {
        hr_id: "",
        hr_periodo: "",
        asid_lunes: "",
        asdesc_lunes: "",
        asid_martes: "",
        asdesc_martes: "",
        asid_miercoles: "",
        asdesc_miercoles: "",
        asid_jueves: "",
        asdesc_jueves: "",
        asid_viernes: "",
        asdesc_viernes: "",
        hr_hourstart: new Date().toString(),
        hr_hourend: new Date().toString(),
      },
      dataGrades: [],
      dataGradeSelected: {
        gr_id: "",
        gr_desc: "",
      },
      isOpenModalAddHour: false,
      isOpenModalEditHour: false,
      loading: false,
      msg_error:""
    };

    this.fetchGrade = this.fetchGrade.bind(this);
    this.fetchHour = this.fetchHour.bind(this);
    this.fetchAsignature = this.fetchAsignature.bind(this);
    this.setAsignatura = this.setAsignatura.bind(this);
    this.handlerModalADDHour = this.handlerModalADDHour.bind(this);
    this.onChangeDatePickerStart = this.onChangeDatePickerStart.bind(this);
    this.onChangeDatePickerEnd = this.onChangeDatePickerEnd.bind(this);
    this.handlerPostHour = this.handlerPostHour.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handlerModaleditHour = this.handlerModaleditHour.bind(this);
    this.handlerSetDataEdit = this.handlerSetDataEdit.bind(this);
    this.columnModalEditHour = this.columnModalEditHour.bind(this);
    this.handlerPutHour = this.handlerPutHour.bind(this);
    this.handlerDeleteRow = this.handlerDeleteRow.bind(this);
  }

  async fetchGrade() {
    const response = await getGrades();
    this.setState({
      dataGrades: response,
      msg_error:""
    });
  }

  async fetchAsignature() {
    const response = await getAllsignature();
    this.setState({
      dataAsignature: response,
      msg_error:""
    });
  }

  async fetchHour({gr_id, gr_desc}:IGradeSelected) {
    const response = await getHourByGrade(gr_id);
    this.setState({
      dataHour: response,
      dataGradeSelected: { gr_id, gr_desc },
      loading: false,
      msg_error:""
    });
  }

  componentDidMount() {
    if(validateTokenStorage()){
      this.context.quitToken();
    }
    this.fetchGrade();
    this.fetchAsignature();
  }

  handlerModalADDHour() {
    this.setState((prevState) => ({
      isOpenModalAddHour: !prevState.isOpenModalAddHour,
      formDias: {
        hr_id: "",
        hr_periodo: "",
        asid_lunes: "",
        asdesc_lunes: "",
        asid_martes: "",
        asdesc_martes: "",
        asid_miercoles: "",
        asdesc_miercoles: "",
        asid_jueves: "",
        asdesc_jueves: "",
        asid_viernes: "",
        asdesc_viernes: "",
        hr_hourstart: new Date().toString(),
        hr_hourend: new Date().toString(),
      },
      msg_error:""
    }));
  }

  handlerModaleditHour() {
    this.setState((prevState) => ({
      isOpenModalEditHour: !prevState.isOpenModalEditHour,
      msg_error:""
    }));
  }

  setAsignatura = (as_id:string, as_desc:string, asid:string, asdesc:string) => {
    this.setState({
      formDias: {
        ...this.state.formDias,
        [asid]: as_id,
        [asdesc]: as_desc,
      },
      msg_error:""
    });
  };

  onChangeDatePickerStart(date: string) {
    this.setState({
      formDias: {
        ...this.state.formDias,
        hr_hourstart: date,
      },
      msg_error:""
    });
  }

  onChangeDatePickerEnd(date: string) {
    this.setState({
      formDias: {
        ...this.state.formDias,
        hr_hourend: date,
      },
      msg_error:""
    });
  }

  handlerPostHour() {
    const props = this.state.formDias;
    const propsGrades = this.state.dataGradeSelected;
    if(props.asid_lunes.length>0 && props.asid_martes.length>0 && props.asid_miercoles.length>0 && props.asid_jueves.length>0 && props.asid_viernes.length>0 ){
      const body = {
        hr_grade: propsGrades.gr_id,
        hr_hourstart: moment(props.hr_hourstart).format("YYYY-MM-DD HH:mm:ss"),
        hr_hourend: moment(props.hr_hourend).format("YYYY-MM-DD HH:mm:ss"),
        hr_lunes: props.asid_lunes,
        hr_martes: props.asid_martes,
        hr_miercoles: props.asid_miercoles,
        hr_jueves: props.asid_jueves,
        hr_viernes: props.asid_viernes,
      };
      postHour(body);
      this.setState({ isOpenModalAddHour: false });
      setTimeout(() => {
        this.fetchHour({gr_id:propsGrades.gr_id, gr_desc: propsGrades.gr_desc});
      }, 1000);
    }
    else{
      this.setState({ msg_error: "Campos vacios" });
    }

  }

  handlerPutHour() {
    const props = this.state.formDias;
    const propsGrades = this.state.dataGradeSelected;
    const body = {
      hr_id: props.hr_id,
      hr_hourstart: moment(props.hr_hourstart).format("YYYY-MM-DD HH:mm:ss"),
      hr_hourend: moment(props.hr_hourend).format("YYYY-MM-DD HH:mm:ss"),
      hr_lunes: props.asid_lunes,
      hr_martes: props.asid_martes,
      hr_miercoles: props.asid_miercoles,
      hr_jueves: props.asid_jueves,
      hr_viernes: props.asid_viernes,
    };
    putHour(body);
    this.setState({ isOpenModalEditHour: false, loading: true });
    setTimeout(() => {
      this.fetchHour({gr_id:propsGrades.gr_id, gr_desc: propsGrades.gr_desc});
    }, 1000);
  }

  rechargeData() {
    const propsGRades = this.state.dataGradeSelected;
    this.setState({ loading: true,msg_error:"" });
    setTimeout(() => {
      this.fetchHour({gr_id:propsGRades.gr_id, gr_desc: propsGRades.gr_desc});
    }, 1000);
  }

  handlerDeleteRow(hr_id: string) {
    const propsGRades = this.state.dataGradeSelected;
    const body = {
      hr_id,
    };
    deleteHour(body);

    this.setState({ loading: true,msg_error:"" });
    setTimeout(() => {
      this.fetchHour({gr_id:propsGRades.gr_id, gr_desc: propsGRades.gr_desc});
    }, 1000);
  }

  handlerSetDataEdit(row: IDiasByAsignatures) {
    this.setState((prevState) => ({
      formDias: row,
      isOpenModalEditHour: true,
      msg_error:""
    }));
  }

  columnModalEditHour(cell:number, row:IDiasByAsignatures) {
    return (
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handlerSetDataEdit(row)}>
            {row.hr_periodo}
          </Label>

          <img className="img-pencil ml-3" onClick={() => this.handlerSetDataEdit(row)} src={PENCIL} alt="" />
          <img className="img-pencil ml-3" onClick={() => this.handlerDeleteRow(row.hr_id)} src={LOGOUT_ICON} alt="" />
        </Col>
      </Row>
    );
  }

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenModalAddHour && (
          <HorarioModal
            title="Agregar Horario"
            dataForm={props.formDias}
            dataAsig={props.dataAsignature}
            setAsignatura={this.setAsignatura}
            onChangeDatePickerStart={this.onChangeDatePickerStart}
            onChangeDatePickerEnd={this.onChangeDatePickerEnd}
            isOpen={props.isOpenModalAddHour}
            toggle={this.handlerModalADDHour}
            toggleSave={this.handlerPostHour}
          />
        )}

        {props.isOpenModalEditHour && (
          <HorarioModal
            title="Editar Horario"
            dataForm={props.formDias}
            dataAsig={props.dataAsignature}
            setAsignatura={this.setAsignatura}
            onChangeDatePickerStart={this.onChangeDatePickerStart}
            onChangeDatePickerEnd={this.onChangeDatePickerEnd}
            isOpen={props.isOpenModalEditHour}
            toggle={this.handlerModaleditHour}
            toggleSave={this.handlerPutHour}
          />
        )}

        <Container className="mt-4">
          <Row>
            <Col sm={12} className="text-center">
              <Label className="font-weight-bold">
                <h3>Horarios</h3>
              </Label>
            </Col>
            <Col sm={12} className="text-right mb-3"></Col>
            <Col sm={12}>
              <DatatableExpand
                data={props.dataGrades}
                columns={COLUMNS_GRADES()}
                keyProp="gr_id"
                expandRow={EXPAND_ROW_GRADE_HOUR(
                  props.dataHour,
                  this.fetchHour,
                  this.handlerModalADDHour,
                  this.rechargeData,
                  props.loading,
                  this.columnModalEditHour
                )}
                exportD={false}
                searchs={false}
              />
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}
export default Hour;
